<template>
  <div class="aigc-sidebar">
    <div class="aigc-sidebar-header">
      <span class="aigc-sidebar-brand">白云AI短剧创作平台</span>
    </div>
    <div class="aigc-sidebar-body">
      <div v-for="group in menuGroups" :key="group.title" class="aigc-sidebar-group">
        <div class="aigc-sidebar-group-title">{{ group.title }}</div>
        <div
          v-for="item in group.items"
          :key="item.key"
          class="aigc-sidebar-item"
          :class="{ 'is-active': isItemActive(item.key) }"
          @click="onItemClick(item.key)"
        >
          <van-icon :name="item.icon" class="aigc-sidebar-item-icon" />
          <span class="aigc-sidebar-item-label">{{ item.label }}</span>
        </div>
      </div>
    </div>
    <div class="aigc-sidebar-footer">
      <van-button
        block
        round
        type="info"
        color="#5B7FFF"
        class="aigc-sidebar-create-btn"
        @click="onStartCreate"
      >
        开始创作
      </van-button>
    </div>
  </div>
</template>

<script>
import { AIGC_MENU_GROUPS } from "./aigcNavConfig";

export default {
  name: "AigcSidebar",
  props: {
    activeRouteName: { type: String, default: "" },
  },
  data() {
    return {
      menuGroups: AIGC_MENU_GROUPS,
    };
  },
  methods: {
    isItemActive(key) {
      const name = this.activeRouteName;
      if (!name || !key) return false;
      if (name === key) return true;
      if (key === "aigc_home" && (name === "aigc_home" || name === "aigc_create")) return true;
      if (key === "aigc_create" && name === "aigc_create") return true;
      if (key === "aigc_real_human_liveness" && name === "aigc_real_human_liveness") return true;
      return false;
    },
    onItemClick(key) {
      this.$emit("nav", key);
    },
    onStartCreate() {
      this.$emit("create");
    },
  },
};
</script>

<style scoped>
.aigc-sidebar {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f7f8fa;
}

.aigc-sidebar-header {
  flex-shrink: 0;
  padding: calc(16px + env(safe-area-inset-top)) 16px 14px;
  background: linear-gradient(135deg, #5b7fff 0%, #6b8cff 100%);
}

.aigc-sidebar-brand {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  line-height: 1.35;
}

.aigc-sidebar-body {
  flex: 1;
  overflow-y: auto;
  padding: 12px 10px 8px;
}

.aigc-sidebar-group {
  margin-bottom: 14px;
}

.aigc-sidebar-group-title {
  padding: 4px 10px 8px;
  font-size: 12px;
  color: #909399;
}

.aigc-sidebar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 12px;
  margin-bottom: 2px;
  border-radius: 8px;
  color: #303133;
  font-size: 14px;
}

.aigc-sidebar-item.is-active {
  background: rgba(91, 127, 255, 0.12);
  color: #5b7fff;
  font-weight: 500;
}

.aigc-sidebar-item-icon {
  font-size: 18px;
  flex-shrink: 0;
}

.aigc-sidebar-item-label {
  flex: 1;
  min-width: 0;
}

.aigc-sidebar-footer {
  flex-shrink: 0;
  padding: 12px 14px calc(14px + env(safe-area-inset-bottom));
  background: #f7f8fa;
  border-top: 1px solid #ebeef5;
}

.aigc-sidebar-create-btn {
  height: 44px;
  font-size: 15px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/views/aigc/AigcSidebar.vue